
import '../styles/app.scss';

window.easings = {};
window.easings.ease = "cubicBezier(0.25, 0.46, 0.45, 0.94)";
window.easings.andrew = "cubicBezier(0.77, 0, 0.175, 1)";
window.easings.feebles1 = "cubicBezier(.8,.03,.25,1)";
window.easings.feebles2 = "cubicBezier(.72,.01,.25,1)";
window.easings.ease2 = "cubicBezier(.48,.1,.48,.9)";

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
  this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();

var sitewideInited = false;

// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import Banner from "../components/molecules/Global/Banner/Banner";
import NewsletterPopup from "../components/molecules/Global/NewsletterPopup/NewsletterPopup";
import CodeEmbed from "../components/molecules/Misc/CodeEmbed/CodeEmbed";
import ProjectImageDuo from "../components/molecules/Project/ProjectImageDuo/ProjectImageDuo";
import ProjectImageSingle from "../components/molecules/Project/ProjectImageSingle/ProjectImageSingle";
import CareerTextContent from "../components/molecules/Career/CareerTextContent/CareerTextContent";
import ListingTeamMembers from "../components/molecules/Listing/ListingTeamMembers/ListingTeamMembers";
import HeroTeamMember from "../components/molecules/Hero/HeroTeamMember/HeroTeamMember";
import ContentHeadingWithInfoItems from "../components/molecules/Content/ContentHeadingWithInfoItems/ContentHeadingWithInfoItems";
import ListingStats from "../components/molecules/Listing/ListingStats/ListingStats";
import ArticlePodcastSignoff from "../components/molecules/Article/ArticlePodcastSignoff/ArticlePodcastSignoff";
import ImageGrid from "../components/molecules/Image/ImageGrid/ImageGrid";
import FilterButtons from "../components/elements/FilterButtons/FilterButtons";
import ButtonTextLink from "../components/atoms/ButtonTextLink/ButtonTextLink";
import Blockquote from "../components/molecules/Content/Blockquote/Blockquote";
import VideoFullWidth from "../components/molecules/Video/VideoFullWidth/VideoFullWidth";
import ArticleInlineCode from "../components/molecules/Article/ArticleInlineCode/ArticleInlineCode";
import ArticleBlockquote from "../components/molecules/Article/ArticleBlockquote/ArticleBlockquote";
import ArticleImage from "../components/molecules/Article/ArticleImage/ArticleImage";
import ArticleTextContent from "../components/molecules/Article/ArticleTextContent/ArticleTextContent";
import ArticleIntro from "../components/molecules/Article/ArticleIntro/ArticleIntro";
import IconItem from "../components/elements/IconItem/IconItem";
import ContentIconItemsTimeline from "../components/molecules/Content/ContentIconItemsTimeline/ContentIconItemsTimeline";
import EntryCardFullWidth from "../components/elements/EntryCardFullWidth/EntryCardFullWidth";
import ListingFullWidthEntryCards from "../components/molecules/Listing/ListingFullWidthEntryCards/ListingFullWidthEntryCards";
import LayoutPodcastPage from "../components/molecules/Layout/LayoutPodcastPage/LayoutPodcastPage";
import Pagination from "../components/elements/Pagination/Pagination";
import EntryCardSimple from "../components/elements/EntryCardSimple/EntryCardSimple";
import ListingThreeUpEntryCards from "../components/molecules/Listing/ListingThreeUpEntryCards/ListingThreeUpEntryCards";
import ButtonsGroup from "../components/elements/ButtonsGroup/ButtonsGroup";
import LayoutJournalPage from "../components/molecules/Layout/LayoutJournalPage/LayoutJournalPage";
import FormSimple from "../components/molecules/Form/FormSimple/FormSimple";
import CtaMedium from "../components/molecules/Cta/CtaMedium/CtaMedium";
import ContentFourUpInfoItems from "../components/molecules/Content/ContentFourUpInfoItems/ContentFourUpInfoItems";
import ImageOneUpLarge from "../components/molecules/Image/ImageOneUpLarge/ImageOneUpLarge";
import ImageTwoUp from "../components/molecules/Image/ImageTwoUp/ImageTwoUp";
import ImageFullWidth from "../components/molecules/Image/ImageFullWidth/ImageFullWidth";
import ContentHeadingWithTwoColumnText from "../components/molecules/Content/ContentHeadingWithTwoColumnText/ContentHeadingWithTwoColumnText";
import ImageTwoUpFullBleed from "../components/molecules/Image/ImageTwoUpFullBleed/ImageTwoUpFullBleed";
import Footer from "../components/molecules/Footer/Footer/Footer";
import CtaSmall from "../components/molecules/Cta/CtaSmall/CtaSmall";
import ContentLogos from "../components/molecules/Content/ContentLogos/ContentLogos";
import CtaLarge from "../components/molecules/Cta/CtaLarge/CtaLarge";
import ContentFourUpIconItems from "../components/molecules/Content/ContentFourUpIconItems/ContentFourUpIconItems";
import CtaButton from "../components/molecules/Cta/CtaButton/CtaButton";
import ListingOneUpEntryCard from "../components/molecules/Listing/ListingOneUpEntryCard/ListingOneUpEntryCard";
import EntryCard from "../components/elements/EntryCard/EntryCard";
import ListingTwoUpEntryCards from "../components/molecules/Listing/ListingTwoUpEntryCards/ListingTwoUpEntryCards";
import ContentHeadingWithText from "../components/molecules/Content/ContentHeadingWithText/ContentHeadingWithText";
import HeroSimplePageHeading from "../components/molecules/Hero/HeroSimplePageHeading/HeroSimplePageHeading";
import NavOverlay from "../components/molecules/Navigation/NavOverlay/NavOverlay";
import NavBar from "../components/elements/NavBar/NavBar";
import HeroBackgroundVideo from "../components/molecules/Hero/HeroBackgroundVideo/HeroBackgroundVideo";
import ButtonPrimary from "../components/atoms/ButtonPrimary/ButtonPrimary";

$(document).ready(function(){

  var components = [
    // Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".comp-Banner", require: Banner },
{handle: ".mol-NewsletterPopup", require: NewsletterPopup },
{handle: ".comp-CodeEmbed", require: CodeEmbed },
{handle: ".comp-ProjectImageDuo", require: ProjectImageDuo },
{handle: ".comp-ProjectImageSingle", require: ProjectImageSingle },
{handle: ".comp-CareerTextContent", require: CareerTextContent },
{handle: ".comp-ListingTeamMembers", require: ListingTeamMembers },
{handle: ".comp-HeroTeamMember", require: HeroTeamMember },
{handle: ".comp-ContentHeadingWithInfoItems", require: ContentHeadingWithInfoItems },
{handle: ".comp-ListingStats", require: ListingStats },
{handle: ".comp-ArticlePodcastSignoff", require: ArticlePodcastSignoff },
{handle: ".comp-ImageGrid", require: ImageGrid },
{handle: ".el-FilterButtons", require: FilterButtons },
{handle: ".atom-ButtonTextLink", require: ButtonTextLink },
{handle: ".comp-Blockquote", require: Blockquote },
{handle: ".comp-VideoFullWidth", require: VideoFullWidth },
{handle: ".comp-ArticleInlineCode", require: ArticleInlineCode },
{handle: ".comp-ArticleBlockquote", require: ArticleBlockquote },
{handle: ".comp-ArticleImage", require: ArticleImage },
// {handle: ".comp-ArticleInlineImages", require: ArticleInlineImages },
{handle: ".comp-ArticleTextContent", require: ArticleTextContent },
{handle: ".comp-ArticleIntro", require: ArticleIntro },
{handle: ".el-IconItem", require: IconItem },
{handle: ".el-EntryCardFullWidth", require: EntryCardFullWidth },
{handle: ".comp-ListingFullWidthEntryCards", require: ListingFullWidthEntryCards },
{handle: ".comp-LayoutPodcastPage", require: LayoutPodcastPage },
{handle: ".el-Pagination", require: Pagination },
{handle: ".el-EntryCardSimple", require: EntryCardSimple },
{handle: ".comp-ListingThreeUpEntryCards", require: ListingThreeUpEntryCards },
{handle: ".el-ButtonsGroup", require: ButtonsGroup },
{handle: ".comp-LayoutJournalPage", require: LayoutJournalPage },
{handle: ".comp-FormSimple", require: FormSimple },
{handle: ".comp-CtaMedium", require: CtaMedium },
{handle: ".comp-ContentFourUpInfoItems", require: ContentFourUpInfoItems },
{handle: ".comp-ImageOneUpLarge", require: ImageOneUpLarge },
{handle: ".comp-ImageTwoUp", require: ImageTwoUp },
{handle: ".comp-ImageFullWidth", require: ImageFullWidth },
{handle: ".comp-ContentHeadingWithTwoColumnText", require: ContentHeadingWithTwoColumnText },
{handle: ".comp-ImageTwoUpFullBleed", require: ImageTwoUpFullBleed },
{handle: ".comp-Footer", require: Footer },
{handle: ".comp-CtaSmall", require: CtaSmall },
{handle: ".comp-ContentLogos", require: ContentLogos },
{handle: ".comp-CtaLarge", require: CtaLarge },
{handle: ".comp-ContentFourUpIconItems", require: ContentFourUpIconItems },
{handle: ".comp-CtaButton", require: CtaButton },
{handle: ".comp-ListingOneUpEntryCard", require: ListingOneUpEntryCard },
{handle: ".el-EntryCard", require: EntryCard },
{handle: ".comp-ListingTwoUpEntryCards", require: ListingTwoUpEntryCards },
{handle: ".comp-ContentHeadingWithText", require: ContentHeadingWithText },
{handle: ".comp-HeroSimplePageHeading", require: HeroSimplePageHeading },
{handle: ".comp-NavOverlay", require: NavOverlay },
{handle: ".el-NavBar", require: NavBar },
{handle: ".comp-HeroBackgroundVideo", require: HeroBackgroundVideo },
{handle: ".atom-ButtonPrimary", require: ButtonPrimary },
  ];

  if (!sitewideInited) {
    var sitewide = new Sitewide();
    sitewide.init();
    sitewideInited = true;
  }

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({components: components});
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

});

/*
 *  Components that shouldn't init until after window.load should go here
 *
 *  This was put in place to solve the problem of window.load firing before document.ready,
 *  which was causing component code placed inside a window.load event to never fire.
 */
$(window).on('load', function(){

  var components = [
{handle: ".comp-ContentIconItemsTimeline", require: ContentIconItemsTimeline },
  ];

  if (!sitewideInited) {
    var sitewide = new Sitewide();
    sitewide.init();
    sitewideInited = true;
  }

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({components: components});
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

});
